export default {
      id: "oc-res-k8s-secret-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-k8s-secret",
      toString: function () {
        return this.url;
      }
    }